module.exports = __webpack_public_path__ + "images/114_640.jpg";